module.exports = __webpack_public_path__ + "static/media/Rectangle 12888.6ce3c08d.png";